// Deferral schedules — deferral_schedules.* (Finance)
//
// Prepaid expenses, accrued liabilities and unearned revenue: one register,
// one set of keys, because they are one mechanism pointing in three directions.
//
// The backend keys are registered by amer-laravel's
// `2026_09_21_000002_add_finance_close_and_control_and_department_restore_permissions`.
// The ids below are the central key service's **approval numbers** (approved
// 21 Sep 2026), which that migration writes as each permission row's own `permissions.id` — the two have to stay
// equal. An id here that does not match its backend row fails silently:
// `HAS_PERMISSION` simply returns false, so the page, the sidebar leaf and every
// gated button never appear, with nothing logged anywhere. Read an issued id;
// never derive the next one from the last.

/** deferral_schedules.index — the register, and opening a row in it. */
export const DEFERRAL_SCHEDULES_INDEX = 1618;

/**
 * There is no `deferral_schedules.show` key — the August 2026 audit collapsed
 * detail routes into their module's `index`, and the route file guards
 * `GET /{id}` with `index` accordingly.
 *
 * Aliased rather than pointed at a key that does not exist: a constant naming a
 * missing key makes `HAS_PERMISSION` false forever and the record page vanishes
 * for everyone.
 */
export const DEFERRAL_SCHEDULES_SHOW = DEFERRAL_SCHEDULES_INDEX;

/** deferral_schedules.create — raising a schedule and cutting it into instalments. */
export const DEFERRAL_SCHEDULES_CREATE = 1619;

/**
 * deferral_schedules.update — re-planning an untouched schedule, correcting a
 * posted one's narration, and cancelling or reactivating it.
 *
 * One key for all of those because the API is one endpoint; which of them a given
 * record still allows is decided by `can_be_replanned`, not by a second key.
 */
export const DEFERRAL_SCHEDULES_UPDATE = 1620;

/** deferral_schedules.delete — only ever reachable while nothing has been released. */
export const DEFERRAL_SCHEDULES_DELETE = 1621;

/**
 * deferral_schedules.release — posting one instalment to the income statement.
 *
 * Its own key, not `update`: this writes a ledger entry that cannot be edited
 * afterwards, and someone trusted to correct a narration is not necessarily
 * trusted to recognise revenue.
 */
export const DEFERRAL_SCHEDULES_RELEASE = 1622;
